import { iosCustomUrlSchemes, navigateToHlAppDeeplink } from '@/models/hl-app/custom-url-scheme'
import { HlAppMode } from '@/models/hl-app/hl-app-mode'
import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'

@Mixin
export class HlAppModeMixin extends Vue {
  get hlAppMode() {
    return HlAppMode
  }

  closeWebView() {
    navigateToHlAppDeeplink(iosCustomUrlSchemes.close)
  }

  goToHlAppOrderComplete() {
    navigateToHlAppDeeplink(iosCustomUrlSchemes.orderComplete)
  }

  goToMyPage() {
    navigateToHlAppDeeplink(iosCustomUrlSchemes.mypage)
  }
}
